import React, { useState, useEffect } from "react";
import { useRef } from "react";
import { Button, Modal } from "semantic-ui-react";
import PropTypes from "prop-types";

export default function CapturePicDialog({ open, onClose, onSave }) {
  const [pic, setPic] = useState();
  const videoRef = useRef();
  const canvasRef = useRef();

  useEffect(() => {
    if (!open) return;
    (async () => {
      let stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: false });
      videoRef.current.srcObject = stream;
      setPic();
    })();
  }, [open]);

  const takePhoto = () => {
    canvasRef.current
      .getContext("2d")
      .drawImage(videoRef.current, 0, 0, canvasRef.current.width, canvasRef.current.height);
    let image_data_url = canvasRef.current.toDataURL("image/jpeg");
    setPic(image_data_url);
  };

  return (
    <Modal open={open} onClose={onClose} dimmer centered style={{height: 500, width: 666}}>
      <div style={{ position: "relative", }}>
        <video style={{ display: pic ? "none" : "" }} ref={videoRef} autoPlay height={500} width="100%"/>
        <canvas style={{ display: pic ? "" : "none" }} ref={canvasRef} height={500} width={666}/>
        {!pic && <Button className="take-pic-button" color="facebook" circular icon="camera" onClick={takePhoto}>
        </Button>}
        {pic && (
          <div className="photo-confirmation">
            <Button circular color="red" size="big" icon="x" onClick={() => setPic()}></Button>
            <Button circular color="green" size="big" icon="check" onClick={() => onSave(pic)}></Button>
          </div>
        )}
      </div>
    </Modal>
  );
}

CapturePicDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onSave: PropTypes.func,
};
